import {
  makeSimpleGetRequest,
  makeSimplePatchRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import {
  CreateValidateRoyaltyAccountCredentialsTaskPayload,
  ValidateRoyaltyAccountCredentialsTask,
} from "./types";

const VALIDATE_ROYALTY_ACCOUNT_CREDENTIAL_URL = `${ORDERBOOK_URL}/validate-royalty-account-credentials-tasks`;

export const createValidateRoyaltyAccountCredentialsTask = async (
  payload: CreateValidateRoyaltyAccountCredentialsTaskPayload,
) =>
  makeSimplePostRequest<ValidateRoyaltyAccountCredentialsTask>(
    `${VALIDATE_ROYALTY_ACCOUNT_CREDENTIAL_URL}/`,
    JSON.stringify(payload || {}),
    [200, 201],
  );

export const updateValidateRoyaltyAccountCredentialsTask = async (
  taskId: number,
  payload: Partial<CreateValidateRoyaltyAccountCredentialsTaskPayload>,
) =>
  makeSimplePatchRequest<ValidateRoyaltyAccountCredentialsTask>(
    `${VALIDATE_ROYALTY_ACCOUNT_CREDENTIAL_URL}/${taskId}`,
    JSON.stringify(payload || {}),
    [200],
  );

export const getValidateRoyaltyAccountCredentialsTask = async (
  taskId: number,
): Promise<ValidateRoyaltyAccountCredentialsTask> => {
  return await makeSimpleGetRequest(
    `${VALIDATE_ROYALTY_ACCOUNT_CREDENTIAL_URL}/${taskId}`,
  );
};
